import { AnalyzeConstants } from '../../../src/_constants/Analyze/analyze.constants';

const initialState = { getlndLoading: true, data: '', error: false, errorMessage: '' };

export function lndDataReducer(state = initialState, action) {

    switch (action.type) {
        case AnalyzeConstants.REQUEST_LnD_DATA:
            return {
                getlndLoading: true,
                data: '',
                error: false,
                errorMessage: ''
            };
        case AnalyzeConstants.RECEIVE_LnD_DATA:
            return {
                getlndLoading: false,
                data: action.res,
                error: false,
                errorMessage: ''
            };
        case AnalyzeConstants.ERROR_LnD_DATA:
            return {
                getlndLoading: false,
                data: '',
                error: true,
                errorMessage: action.error.message ? 'Something Went Wrong while Collecting Data!' : action.error.response.data.message !== undefined ? action.error.response.data.message : 'Something Went Wrong!'
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/l&dData.reducer.js